module.exports = __webpack_public_path__ + "img/11-1.c673ab7b.png";